var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticStyle: { height: "30px", "border-bottom": "1px solid #ddd" } },
        [_c("el-col", { attrs: { span: 24 } }, [_vm._v(" 代采版偏好设置 ")])],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "50px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [_vm._v("\n    开单-报单页面,商家代采计划列表的微信分享文案\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { rows: 5, type: "textarea", placeholder: "" },
            model: {
              value: _vm.kdbd_text,
              callback: function($$v) {
                _vm.kdbd_text = $$v
              },
              expression: "kdbd_text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "50px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [_vm._v("\n    开单-核单页面,商家代采订单列表的微信分享文案\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { rows: 5, type: "textarea", placeholder: "" },
            model: {
              value: _vm.kdhd_text,
              callback: function($$v) {
                _vm.kdhd_text = $$v
              },
              expression: "kdhd_text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "50px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [_vm._v("\n    开单-回执页面,财务付款拼争列表的微信分享文案\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { rows: 5, type: "textarea", placeholder: "" },
            model: {
              value: _vm.kdhz_text,
              callback: function($$v) {
                _vm.kdhz_text = $$v
              },
              expression: "kdhz_text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "50px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [_vm._v("\n    报单-代采计划商品列表的微信分享文案\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { rows: 5, type: "textarea", placeholder: "" },
            model: {
              value: _vm.cgjh_text,
              callback: function($$v) {
                _vm.cgjh_text = $$v
              },
              expression: "cgjh_text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "50px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [_vm._v("\n    回执-财务已支付的付款回执微信分享文案\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { rows: 5, type: "textarea", placeholder: "" },
            model: {
              value: _vm.fkhz_text,
              callback: function($$v) {
                _vm.fkhz_text = $$v
              },
              expression: "fkhz_text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "50px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [_vm._v("\n    爆版订货单-今日实时订单池 提示文案\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-input", {
            staticStyle: { width: "600px" },
            attrs: { rows: 5, type: "textarea", placeholder: "" },
            model: {
              value: _vm.bbdhd_text,
              callback: function($$v) {
                _vm.bbdhd_text = $$v
              },
              expression: "bbdhd_text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "50px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [_vm._v("\n    代采版待开单页面，商家名称“红色”显示设置\n  ")]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm._v("\n    商家代采计划超过\n    "),
          _c("el-input", {
            staticStyle: { width: "100px" },
            attrs: { type: "text", placeholder: "" },
            model: {
              value: _vm.overdue_day,
              callback: function($$v) {
                _vm.overdue_day = $$v
              },
              expression: "overdue_day"
            }
          }),
          _vm._v("\n    天还没进行操作\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm._v("\n    采购计划待开单超过\n    "),
          _c("el-input", {
            staticStyle: { width: "100px" },
            attrs: { type: "text", placeholder: "" },
            model: {
              value: _vm.outdo_day,
              callback: function($$v) {
                _vm.outdo_day = $$v
              },
              expression: "outdo_day"
            }
          }),
          _vm._v("\n    天自动加入急救箱，同时商品库\n    "),
          _c(
            "el-select",
            {
              attrs: { filterable: "" },
              model: {
                value: _vm.is_disable,
                callback: function($$v) {
                  _vm.is_disable = $$v
                },
                expression: "is_disable"
              }
            },
            [
              _c("el-option", { attrs: { value: "1", label: "商品货号禁用" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { value: "2", label: "不改动" } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm._v("\n    SKU单日备货件数大于\n    "),
          _c("ys-input", {
            staticStyle: { width: "100px" },
            attrs: { pattern: "positiveInt", placeholder: "" },
            model: {
              value: _vm.limit_no_pre_storage_sku,
              callback: function($$v) {
                _vm.limit_no_pre_storage_sku = $$v
              },
              expression: "limit_no_pre_storage_sku"
            }
          }),
          _vm._v("\n    件，非前置仓的备货计划需要审核\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm._v("\n    前置仓库存里，当某SKU寄售期（最早的一件）超过\n    "),
          _c("ys-input", {
            staticStyle: { width: "150px" },
            attrs: { pattern: "positiveInt", placeholder: "填写天数" },
            model: {
              value: _vm.pre_stock_advent_day,
              callback: function($$v) {
                _vm.pre_stock_advent_day = $$v
              },
              expression: "pre_stock_advent_day"
            }
          }),
          _vm._v("\n    天，将通知商家即将退供（SKU的所有库存）。超过\n    "),
          _c("ys-input", {
            staticStyle: { width: "150px" },
            attrs: { pattern: "positiveInt", placeholder: "填写天数" },
            model: {
              value: _vm.pre_stock_auto_return_day,
              callback: function($$v) {
                _vm.pre_stock_auto_return_day = $$v
              },
              expression: "pre_stock_auto_return_day"
            }
          }),
          _vm._v("\n\n    天，将自动生产退供单进入退供流程。\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: {
            height: "80px",
            "font-size": "15px",
            "line-height": "50px"
          }
        },
        [
          _c(
            "el-button",
            {
              staticStyle: {
                width: "80px",
                "margin-top": "30px",
                "margin-left": "625px"
              },
              attrs: { type: "info" },
              on: { click: _vm.cancel }
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "80px" },
              attrs: { type: "warning" },
              on: { click: _vm.submit }
            },
            [_vm._v("\n      保存\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b524c90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b524c90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ShareText.vue
// module id = null
// module chunks = 